import React, { Component } from 'react';
import { 
  CatalogIcon,
} from './SVGIcons';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      isMobile: false // По умолчанию false для SSR
    };
    this.timeoutId = null;
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    // Проверяем размер экрана только на клиенте после гидратации
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    
    // Добавляем обработчик клика вне меню для мобильных
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkMobile);
    document.removeEventListener('mousedown', this.handleClickOutside);
    
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  checkMobile = () => {
    // Безопасная проверка на клиенте
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  handleClickOutside = (event) => {
    // Закрываем меню при клике вне компонента на мобильных
    if (this.state.isMobile && 
        this.menuRef.current && 
        !this.menuRef.current.contains(event.target)) {
      this.setState({ isMenuOpen: false });
    }
  };

  handleMouseEnter = () => {
    // На десктопе открываем по наведению
    if (!this.state.isMobile) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.setState({ isMenuOpen: true });
    }
  };

  handleMouseLeave = () => {
    // На десктопе закрываем с задержкой
    if (!this.state.isMobile) {
      this.timeoutId = setTimeout(() => {
        this.setState({ isMenuOpen: false });
      }, 100);
    }
  };

  handleClick = (e) => {
    // На мобильных открываем/закрываем по клику
    e.preventDefault();
    this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen }));
  };

  handleLinkClick = () => {
    // Закрываем меню после клика по ссылке на мобильных
    if (this.state.isMobile) {
      this.setState({ isMenuOpen: false });
    }
  };

  getMenuPositionClasses = () => {
    const { menuPosition = 'bottom' } = this.props;
    
    const positions = {
      top: 'bottom-full left-0 mb-1',
      bottom: 'top-full left-0 mt-1',
      topRight: 'bottom-full right-0 mb-1',
      bottomRight: 'top-full right-0 mt-1',
      topLeft: 'bottom-full left-0 mb-1',
      bottomLeft: 'top-full left-0 mt-1',
    };
    
    return positions[menuPosition] || positions.bottom;
  };

  render() {
    const { className, menu, href } = this.props;
    const { isMenuOpen, isMobile } = this.state;

    return (
      <div 
        ref={this.menuRef}
        className="relative inline-block"
        onMouseLeave={this.handleMouseLeave}
      >
        {isMobile ? (
          // Для мобильных - кнопка без ссылки
          <button 
            className={className}
            onClick={this.handleClick}
            aria-expanded={isMenuOpen}
            aria-haspopup="true"
            type="button"
          >
            <CatalogIcon />
            <span className='text-white'>Каталог</span>
          </button>
        ) : (
          // Для десктопа - ссылка с наведением
          <a 
            href={href} 
            className={className}
            onMouseEnter={this.handleMouseEnter}
            aria-expanded={isMenuOpen}
            aria-haspopup="true"
          >
            <CatalogIcon />
            <span className='text-white text-[14px]'>Каталог</span>
          </a>
        )}
        
        {isMenuOpen && menu && menu.length > 0 && (
          <div 
            className={`absolute ${this.getMenuPositionClasses()} min-w-[250px] bg-white shadow-lg rounded-md py-2 z-50 my-0 animate-fadeIn`}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            {menu.map((item) => (
              <a 
                key={item.id} 
                href={item.url} 
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 text-sm transition-colors duration-200"
                onClick={this.handleLinkClick}
              >
                {item.pagetitle}
              </a>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default App;